<div class="report-category-container grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
  @for (category of categories(); track category.title) {
    <div class="report-category-card flex items-start gap-3 p-4 min-h-[105px]">
      <div class="icon-background flex items-center justify-center w-10 h-10 rounded-lg shrink-0">
        <app-icon-svg
          width="18"
          height="18"
          [iconName]="category.icon"
          color="#49a3a3">
        </app-icon-svg>
      </div>
      <div class="min-w-0">
        <p class="report-category-title font-semibold text-sm mb-1">{{ category.title }}</p>
        <p class="report-category-description text-color-secondary line-clamp-2">{{ category.description }}</p>
      </div>
    </div>
  }
</div>